/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SsoTokenRouteImport } from './routes/sso-token'
import { Route as SsoCallbackRouteImport } from './routes/sso-callback'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LoadingRouteImport } from './routes/loading'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthShardlibraryRouteImport } from './routes/_auth/shardlibrary'
import { Route as AuthShardlibraryIndexRouteImport } from './routes/_auth/shardlibrary/index'
import { Route as AuthShardlibraryCollectionIdIndexRouteImport } from './routes/_auth/shardlibrary/$collectionId/index'
import { Route as AuthShardlibraryCollectionIdShardIdRouteImport } from './routes/_auth/shardlibrary/$collectionId/$shardId'

const SsoTokenRoute = SsoTokenRouteImport.update({
  id: '/sso-token',
  path: '/sso-token',
  getParentRoute: () => rootRouteImport,
} as any)
const SsoCallbackRoute = SsoCallbackRouteImport.update({
  id: '/sso-callback',
  path: '/sso-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LoadingRoute = LoadingRouteImport.update({
  id: '/loading',
  path: '/loading',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthShardlibraryRoute = AuthShardlibraryRouteImport.update({
  id: '/shardlibrary',
  path: '/shardlibrary',
  getParentRoute: () => AuthRoute,
} as any)
const AuthShardlibraryIndexRoute = AuthShardlibraryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthShardlibraryRoute,
} as any)
const AuthShardlibraryCollectionIdIndexRoute =
  AuthShardlibraryCollectionIdIndexRouteImport.update({
    id: '/$collectionId/',
    path: '/$collectionId/',
    getParentRoute: () => AuthShardlibraryRoute,
  } as any)
const AuthShardlibraryCollectionIdShardIdRoute =
  AuthShardlibraryCollectionIdShardIdRouteImport.update({
    id: '/$collectionId/$shardId',
    path: '/$collectionId/$shardId',
    getParentRoute: () => AuthShardlibraryRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/loading': typeof LoadingRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/sso-token': typeof SsoTokenRoute
  '/shardlibrary': typeof AuthShardlibraryRouteWithChildren
  '/shardlibrary/': typeof AuthShardlibraryIndexRoute
  '/shardlibrary/$collectionId/$shardId': typeof AuthShardlibraryCollectionIdShardIdRoute
  '/shardlibrary/$collectionId/': typeof AuthShardlibraryCollectionIdIndexRoute
}
export interface FileRoutesByTo {
  '/loading': typeof LoadingRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/sso-token': typeof SsoTokenRoute
  '/': typeof AuthIndexRoute
  '/shardlibrary': typeof AuthShardlibraryIndexRoute
  '/shardlibrary/$collectionId/$shardId': typeof AuthShardlibraryCollectionIdShardIdRoute
  '/shardlibrary/$collectionId': typeof AuthShardlibraryCollectionIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/loading': typeof LoadingRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/sso-token': typeof SsoTokenRoute
  '/_auth/shardlibrary': typeof AuthShardlibraryRouteWithChildren
  '/_auth/': typeof AuthIndexRoute
  '/_auth/shardlibrary/': typeof AuthShardlibraryIndexRoute
  '/_auth/shardlibrary/$collectionId/$shardId': typeof AuthShardlibraryCollectionIdShardIdRoute
  '/_auth/shardlibrary/$collectionId/': typeof AuthShardlibraryCollectionIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/loading'
    | '/login'
    | '/logout'
    | '/sso-callback'
    | '/sso-token'
    | '/shardlibrary'
    | '/shardlibrary/'
    | '/shardlibrary/$collectionId/$shardId'
    | '/shardlibrary/$collectionId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/loading'
    | '/login'
    | '/logout'
    | '/sso-callback'
    | '/sso-token'
    | '/'
    | '/shardlibrary'
    | '/shardlibrary/$collectionId/$shardId'
    | '/shardlibrary/$collectionId'
  id:
    | '__root__'
    | '/_auth'
    | '/loading'
    | '/login'
    | '/logout'
    | '/sso-callback'
    | '/sso-token'
    | '/_auth/shardlibrary'
    | '/_auth/'
    | '/_auth/shardlibrary/'
    | '/_auth/shardlibrary/$collectionId/$shardId'
    | '/_auth/shardlibrary/$collectionId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  LoadingRoute: typeof LoadingRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  SsoCallbackRoute: typeof SsoCallbackRoute
  SsoTokenRoute: typeof SsoTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sso-token': {
      id: '/sso-token'
      path: '/sso-token'
      fullPath: '/sso-token'
      preLoaderRoute: typeof SsoTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sso-callback': {
      id: '/sso-callback'
      path: '/sso-callback'
      fullPath: '/sso-callback'
      preLoaderRoute: typeof SsoCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/loading': {
      id: '/loading'
      path: '/loading'
      fullPath: '/loading'
      preLoaderRoute: typeof LoadingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/shardlibrary': {
      id: '/_auth/shardlibrary'
      path: '/shardlibrary'
      fullPath: '/shardlibrary'
      preLoaderRoute: typeof AuthShardlibraryRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/shardlibrary/': {
      id: '/_auth/shardlibrary/'
      path: '/'
      fullPath: '/shardlibrary/'
      preLoaderRoute: typeof AuthShardlibraryIndexRouteImport
      parentRoute: typeof AuthShardlibraryRoute
    }
    '/_auth/shardlibrary/$collectionId/': {
      id: '/_auth/shardlibrary/$collectionId/'
      path: '/$collectionId'
      fullPath: '/shardlibrary/$collectionId/'
      preLoaderRoute: typeof AuthShardlibraryCollectionIdIndexRouteImport
      parentRoute: typeof AuthShardlibraryRoute
    }
    '/_auth/shardlibrary/$collectionId/$shardId': {
      id: '/_auth/shardlibrary/$collectionId/$shardId'
      path: '/$collectionId/$shardId'
      fullPath: '/shardlibrary/$collectionId/$shardId'
      preLoaderRoute: typeof AuthShardlibraryCollectionIdShardIdRouteImport
      parentRoute: typeof AuthShardlibraryRoute
    }
  }
}

interface AuthShardlibraryRouteChildren {
  AuthShardlibraryIndexRoute: typeof AuthShardlibraryIndexRoute
  AuthShardlibraryCollectionIdShardIdRoute: typeof AuthShardlibraryCollectionIdShardIdRoute
  AuthShardlibraryCollectionIdIndexRoute: typeof AuthShardlibraryCollectionIdIndexRoute
}

const AuthShardlibraryRouteChildren: AuthShardlibraryRouteChildren = {
  AuthShardlibraryIndexRoute: AuthShardlibraryIndexRoute,
  AuthShardlibraryCollectionIdShardIdRoute:
    AuthShardlibraryCollectionIdShardIdRoute,
  AuthShardlibraryCollectionIdIndexRoute:
    AuthShardlibraryCollectionIdIndexRoute,
}

const AuthShardlibraryRouteWithChildren =
  AuthShardlibraryRoute._addFileChildren(AuthShardlibraryRouteChildren)

interface AuthRouteChildren {
  AuthShardlibraryRoute: typeof AuthShardlibraryRouteWithChildren
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthShardlibraryRoute: AuthShardlibraryRouteWithChildren,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LoadingRoute: LoadingRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  SsoCallbackRoute: SsoCallbackRoute,
  SsoTokenRoute: SsoTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
